<template>
  <div
    class="wwi-product"
    :class="{ 'wwi-product-rainbowify': product.orderable }"
  >
    <div class="wwi-product--title">
      {{ product.title }}
    </div>
    <div class="wwi-product--subtitle">
      {{ $t('components.start.product.subtitle') }}
    </div>
    <ul class="wwi-product--features">
      <li
        v-for="(feature, index) in product.features"
        :key="index"
        :class="{ 'wwi-product--feature-important': feature.important }"
      >
        <svg
          id="Layer_1"
          fill="#000000"
          viewBox="0 -8 72 72"
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title>check</title>
          <path d="M61.07,12.9,57,8.84a2.93,2.93,0,0,0-4.21,0L28.91,32.73,19.2,23A3,3,0,0,0,15,23l-4.06,4.07a2.93,2.93,0,0,0,0,4.21L26.81,47.16a2.84,2.84,0,0,0,2.1.89A2.87,2.87,0,0,0,31,47.16l30.05-30a2.93,2.93,0,0,0,0-4.21Z" />
        </svg>
        {{ feature.name }}
      </li>
    </ul>
    <div class="wwi-product--price">
      <span class="wwi-product--price-currency">{{ product.currency }} </span>
      <span class="wwi-product--price-amount">{{ price }}</span>
      <span class="wwi-product--price-per-month">/{{ $t('general.month') }}</span><br>
      <span
        v-if="product.oldprice"
        class="wwi-product--oldprice"
      ><s>{{ $t('general.instead', {currency: product.currency, oldprice: oldprice}) }}</s><br></span>
      <span>{{ $t('general.charge', {charge: product.currency + ' ' + charge}) }}</span>
    </div>
    <button
      v-if="product.orderable"
      class="wwi-button wwi-button-cta"
      @click="$emit('order', product)"
    >
      {{ $t('general.actions.order') }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    product: {
      default: () => {},
      type: Object
    }
  },
  computed: {
    price () {
      return (this.product.price / 100).toLocaleString('de-' + this.$store.getters['general/contractor'], {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
      })
    },
    oldprice () {
      return (this.product.oldprice / 100).toLocaleString('de-' + this.$store.getters['general/contractor'], {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
      })
    },
    charge () {
      return (this.product.charge / 100).toLocaleString('de-' + this.$store.getters['general/contractor'], {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
      })
    }
  }
}
</script>
